import { render, staticRenderFns } from "./defaultTemplate.vue?vue&type=template&id=381d9147&scoped=true&"
import script from "./defaultTemplate.vue?vue&type=script&lang=js&"
export * from "./defaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./defaultTemplate.css?vue&type=style&index=0&id=381d9147&scoped=true&lang=css&"
import style1 from "./defaultTemplate720.css?vue&type=style&index=1&id=381d9147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d9147",
  null
  
)

export default component.exports